export const HOME = {
  emergentLink: 'home-emergent-link',
};

export const NAV = {
  container: 'site-nav',
  logo: 'nav-logo',
  link: (id) => `nav-link-${id}`,
  cta: 'nav-cta-start',
  mobileToggle: 'nav-mobile-toggle',
};

export const HERO = {
  section: 'hero-section',
  title: 'hero-title',
  subtitle: 'hero-subtitle',
  viewMaps: 'hero-cta-view-maps',
  startProject: 'hero-cta-start-project',
};

export const SECTIONS = {
  whatIs: 'section-what-is',
  whyMatter: 'section-why-matter',
  infoCollect: 'section-info-collect',
  communityProvide: 'section-community-provide',
  outputs: 'section-outputs',
  authority: 'section-authority',
  knowledge: 'section-knowledge',
  examples: 'section-examples',
  contact: 'section-contact',
};

export const FORM = {
  form: 'enquiry-form',
  name: 'enquiry-name',
  organisation: 'enquiry-org',
  email: 'enquiry-email',
  phone: 'enquiry-phone',
  projectType: 'enquiry-project-type',
  region: 'enquiry-region',
  message: 'enquiry-message',
  submit: 'enquiry-submit',
  success: 'enquiry-success',
  error: 'enquiry-error',
};
